export default __webpack_public_path__ + "static/media/Sass_logo.55bf8f12.png";